import { useAppSelector } from "hooks/useStore";
import { useDispatch } from "react-redux";
import {
  removeInteractionId,
  selectIsSearchStepDrawerActive,
  selectSearchStepDrawerInteractionId,
  selectSearchStepDrawerOpenedManually,
  setInteractionId,
} from "store/slices/rightSidebarDrawer";

export const useSearchStepDrawer = () => {
  const dispatch = useDispatch();
  const interactionId = useAppSelector(selectSearchStepDrawerInteractionId);
  const isActive = useAppSelector(selectIsSearchStepDrawerActive);
  const openedManually = useAppSelector(selectSearchStepDrawerOpenedManually);

  const closeSearchStepDrawer = () => {
    dispatch(removeInteractionId());
  };

  const openSearchStepDrawer = (interactionId: string, isManual = false) => {
    dispatch(setInteractionId({ interactionId, isManual }));
  };

  return {
    interactionId,
    isOpen: !!interactionId,
    isActive,
    openedManually,
    closeSearchStepDrawer,
    openSearchStepDrawer,
  };
};
